import TipTapHorizontalRule from '@tiptap/extension-horizontal-rule'

export const HorizontalRule = TipTapHorizontalRule.extend({
  addOptions() {
    return {
      ...this.parent?.(),
      HTMLAttributes: {
        class: "my-4 border-b [.has-focus]:ring-2 [.has-focus]:ring-primary/40"
      },
    }
  },
})
